<template>
    <v-container>
        <v-card>
            <v-card-text>
                <h4 class="primary--text">{{$route.params.id?'Edit':'Create'}} Menu</h4>
                <v-form>
                    <v-text-field type="text" label="Menu Name*" v-model.trim="menu['name'+selectedLocaleIndex]" :name="'name'+selectedLocaleIndex" v-validate="'required'" maxLength="50" autofocus
                                  :error-messages="errors.first('name'+selectedLocaleIndex)"
                    ></v-text-field>

                    <v-text-field type="text" label="Link" v-model="menu.link" name="link"
                                  :error-messages="errors.first('link')"
                    ></v-text-field>

                    <v-text-field type="text" label="Icon" v-model="menu.icon" name="icon"
                                  :error-messages="errors.first('icon')"
                    ></v-text-field>

                    <v-select :items="parentMenus.filter(item=>item.name1 != menu.name1)" label="Parent" v-model="menu.parentId" :item-text="'name'+selectedLocaleIndex" item-value="menuId" :disabled="menu.parentId==0">
                    </v-select>

                    <v-select :items="menuTypes" label="Type" v-model="menu.menuType" item-text="name" item-value="value">
                    </v-select>

                    <v-text-field type="number" label="Order Value" v-model="menu.ordering" name="ordering"
                                  :error-messages="errors.first('ordering')"
                    ></v-text-field>

                    <v-checkbox v-model="menu.active" label="Active" name="active" type="checkbox"
                                :true-value="1"
                                :false-value="0"
                                :error-messages="errors.first('active')"
                    ></v-checkbox>

                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="handleSubmit"><v-icon dark left>save</v-icon>{{$t('lang.common.save')}}</v-btn>
                <v-btn color="error" dark @click="back"><v-icon dark left>cancel</v-icon>{{$t('lang.common.cancel')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
    import {router} from '../../router';
    import {mapState, mapGetters} from 'vuex'
    import {CrudService} from "@/services";
    import {message} from "@/shared/message";
    import {fillOtherLangs} from "@/shared/utils";


    export default {
        name: "MenuEdit",
        data() {
            return {
                submitted: false,
                menu: {
                    dashboard: false
                },
                menuTypes: [{value: 1, name: 'Section'}, {value: 2, name: 'Menu Item'}]
            };
        },
        computed: {
            ...mapState({
                loading: state => state.common.loading
            }),
            ...mapGetters("menu", ["parentMenus"]),
            ...mapGetters(["selectedLocaleIndex"])
        },
        methods: {
            handleSubmit(e) {
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {

                        this.menu = fillOtherLangs(this.menu, 'name');

                        if (this.$route.params.id) {
                            CrudService.of('menu').updateItem(this.menu).then(() => {
                                this.$store.dispatch("menu/getMenus");
                                message.success(`Update Menu Success!`, '/menu/list');
                            });
                        } else {
                            if(this.menu.dashboard){
                                this.menu.link = "#/dashboard";
                            }
                            CrudService.of('menu').createItem(this.menu).then(() => {
                                this.$store.dispatch("menu/getMenus");
                                message.success(`Update Menu Success!`, '/menu/list');
                            });
                        }
                    }
                });
            },
            back() {
                router.push('/menu/list');
            }
        },
        created() {
            if (this.$route.params.id) {
                let me = this;
                CrudService.of('menu').getItem(this.$route.params.id).then(menu => {
                    console.log(menu);
                    me.menu = menu;
                });
            }
        },
    };
</script>
